import cn from 'classnames'
import React from 'react'
import SpacedItems from 'shared/components/ui/SpacedItems'
import { Icon } from 'util/ui'
import { SearchBox } from 'shared/ui'
import LegacyLink from 'components/LegacyLink'
import styles from './styles.less'

export default function CannedReplyDropdownMenuHeader({ onSearchChange }) {
  return (
    <SpacedItems.Container
      className={styles.header}
      direction="horizontal"
      gap="mini"
    >
      <SpacedItems.Item grow={1}>
        <SearchBox
          onSearchChange={onSearchChange}
          placeholder="Search for a response"
          styleVersion="v2"
        />
      </SpacedItems.Item>
      <SpacedItems.Item>
        <LegacyLink
          as="a"
          className={cn('ui basic icon button', styles.button)}
          path="/groove_client/settings/ticketing/canned-replies/new"
          async={false}
          skipModal
          target="_new"
        >
          <Icon name="pencil" />
        </LegacyLink>
      </SpacedItems.Item>
      <SpacedItems.Item>
        <LegacyLink
          as="a"
          className={cn('ui basic icon button', styles.button)}
          path="/groove_client/settings/ticketing/canned-replies"
          async={false}
          skipModal
          target="_new"
        >
          <Icon name="cog" />
        </LegacyLink>
      </SpacedItems.Item>
    </SpacedItems.Container>
  )
}
